export { default } from './InitColorSchemeScript';


//////////////////
// WEBPACK FOOTER
// ../@mui/system/esm/InitColorSchemeScript/index.js
// module id = 1652
// module chunks = 22